<script>
	import { onMount} from "svelte";
	import SimplexNoise from "simplex-noise"

	let width;
	let height;
	let canvas;

	let counter=0;
	let avg_frame_time = 20;
	let prew_frame = 0;

	let yCount = 20;
	let xCount = 35;
	let maxY = 60;
	let minY = 15;
	$: iXCount = 1 / (xCount - 1);
	let iYCount = 1 / (maxY - 1);
	let timeStep = 0.003;
	let noise = new SimplexNoise();

	let ctx;

	let high_frame_time = 40;
	let low_frame_time = 25;

	function resize() {
		canvas.width = width;
		canvas.height = height;
		xCount = Math.floor(width/20);
	}

	function adjust(frame_t) {
		avg_frame_time -= (avg_frame_time - frame_t)/100;

		counter += 1;
		if (counter > 30) {
			counter = 0;
			if (avg_frame_time > high_frame_time) {
				if (yCount > minY) {
					yCount -= 1;
				}
			} else if (avg_frame_time < low_frame_time) {
				if (yCount < maxY) {
					yCount += 1;
				}
			}
		}
	}

	async function draw() {
		adjust((performance.now() - prew_frame));
		prew_frame = performance.now();
		resize();

		let grad = ctx.createLinearGradient(-2*width, 2*height, 2*width, -2*height);
		let time = new Date().getTime() * 0.0001;
		let t = time % 1;
		let tSide = time % 2 < 1;
		let hueA = tSide ? 340 : 210;
		let hueB = !tSide ? 340 : 210;
		let colorA = 'hsl(' + hueA +', 100%, 50%)';
		let colorB = 'hsl(' + hueB +', 100%, 50%)';

		grad.addColorStop(1/6 - t/6, colorA);
		grad.addColorStop(2/6 - t/6, colorB);
		grad.addColorStop(3/6 - t/6, colorA);
		grad.addColorStop(4/6 - t/6, colorB);
		grad.addColorStop(5/6 - t/6, colorA);
		grad.addColorStop(6/6 - t/6, colorB);

		ctx.globalAlpha = Math.cos(time)*0.075+0.30 - 0.1;
		ctx.filter = 'blur(6px)';

		ctx.fillStyle = grad;
		ctx.fillRect(0, 0, width, height);

		ctx.globalAlpha = 0.5;


		ctx.globalCompositeOperation='lighten';
		ctx.beginPath();
		ctx.lineWidth = 10;
		ctx.strokeStyle = grad;
		for(let j = 0; j < yCount; j++) {
			let tj = j * iYCount;
			let c = Math.cos(tj * 2 * Math.PI + time) * 0.1;
			for(let i = 0; i < xCount; i++) {
				let t = i * iXCount;
				let n = noise.noise3D(t, time, c);
				let y = (n * height / 2)+height/2;
				let x = t * (width + 20) - 10;
				if(i==0) {
					ctx.moveTo(x, y);
				} else {
					ctx.lineTo(x, y);
				}
			}
			time += timeStep;
		}
		ctx.stroke();
		ctx.lineWidth = 4;
		ctx.strokeStyle = 'hsl(0,0%,70%,0.8)';
		ctx.stroke();
		window.requestAnimationFrame(draw);
	}

	//set initial canvas size
	onMount(() => { 
		ctx = canvas.getContext('2d');
		let start = performance.now();
		draw();//, 1000/25; //25fps
		avg_frame_time = performance.now() - start;
		//measure_fps();
	});
</script>

<style>
	canvas {
		position: fixed;
		z-index: -1;
	}
</style>

<svelte:window on:resize={resize} bind:innerWidth={width} bind:innerHeight={height}/>

<canvas id="bg" bind:this={canvas}/>

